import { Banner } from "./Banner";
import { t } from "../i18n/t";

/**
 * §B6.6/§A8.6: renders `list_systems().warnings` for the systems a screen is about. It takes the warnings as a
 * prop and fetches nothing, so Connect, Scope and the sign-off dialog all show the same words. §B2.3: on Connect
 * it sits above the Xero card and is not dismissible.
 */
export function SystemWarningBanner({
  warnings,
  systems,
}: {
  warnings: Record<string, string> | undefined;
  systems: readonly (string | null | undefined)[];
}): JSX.Element | null {
  if (warnings === undefined) return null;
  const relevant = systems
    .filter((system): system is string => typeof system === "string" && system !== "")
    .filter((system, index, all) => all.indexOf(system) === index)
    .map((system) => [system, warnings[system]] as const)
    .filter((pair): pair is readonly [string, string] => typeof pair[1] === "string");
  if (relevant.length === 0) return null;
  return (
    <Banner tone="warn" title={t("systems.warning_title")}>
      <ul>
        {relevant.map(([system, message]) => (
          <li key={system}>{message}</li>
        ))}
      </ul>
    </Banner>
  );
}
